export class DefaultMap<K, V> extends Map<K, V> {
  constructor(private defaultFunction: () => V) {
    super();
  }

  get(key: K): V {
    if (!this.has(key)) {
      this.set(key, this.defaultFunction());
    }
    return super.get(key)!;
  }
}
